const statistics = [
	{
		id: 'stat-tobacco-use',
		title: 'Tobacco Use'
	},
	{
		id: 'stat-mental-health',
		title: 'Mental Health'
	},
	{
		id: 'stat-physical-activity',
		title: 'Physical Activity'
	}
];

export default statistics;
